import { Box, Button, Grid2, Paper, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { commonCss } from "../../CssStyle/commonCss";
import {
  AccountTree,
  Architecture,
  Code,
  DeveloperMode,
  People,
  Rocket,
  SettingsSuggest,
} from "@mui/icons-material";

const ContactUs = () => {
  const [contactInfo, setContactInfo] = useState({
    type: "",
    service: "",
    name: "",
    email: "",
    phoneno: "",
  });
  const handleContact = (name, value) => {
    setContactInfo({
      ...contactInfo,
      [name]: value,
    });
  };
  return (
    <Grid2
      container
      justifyContent={"center"}
      // sx={{ p: { xs: "4rem 1rem 0 1rem", md: "4rem 2rem 0 2rem" } }}
    >
      <Grid2
        container
        size={12}
        sx={{ padding: { xs: "1rem", md: "8rem 4rem 4rem 4rem" },maxWidth:{xs:"auto",xl:"2000px"},mt:{xs:"30%",sm:"25%",md:"20%",lg:"15%",xl:"5%"}, }}
        justifyContent={"center"}
        
      >
        <Paper
          elevation={4}
          sx={{
            padding: "2rem",
            borderRadius: 0,
            display: "flex",
            flexDirection: "column",
            gap: "2rem",
            width: { xs: "100", md: "96%", lg: "76%" },
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: commonCss.mainTitleFontSize,
                fontWeight: commonCss.mainTitleFontWeight,
              }}
            >
              Let’s talk about your project
            </Typography>
            <Typography sx={{ fontSize: "0.93rem", mt: 1 }}>
              Our team will review your submission and connect with you within
              24 hours.
            </Typography>
          </Box>
          <Grid2 container sx={{ p: { xs: 0, md: "0rem 1.5rem" } }} spacing={"1rem"}>
            <Grid2 size={12}>
              <Typography
                sx={{
                  fontSize: commonCss.mainTitleFontSize,
                  fontWeight: commonCss.mainTitleFontWeight,
                }}
              >
                What can we do for you?
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                  width: "100%",
                  height: "100%",
                  alignItems: "center",
                }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.06)",
                    padding: "3rem",
                    border:
                      contactInfo.type === "Build a new project"
                        ? `1px solid ${commonCss.blue}`
                        : "none",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleContact("type", "Build a new project");
                  }}
                >
                  <Rocket
                    sx={{
                      fontSize: commonCss.cardIconSize,
                      color: commonCss.blue,
                    }}
                  />
                </Paper>
                <Typography
                  sx={{
                    fontWeight: commonCss.cardTitleWeight,
                    fontSize: commonCss.cardTitleSize,
                  }}
                >
                  Build a new project
                </Typography>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                  width: "100%",
                  height: "100%",
                  alignItems: "center",
                }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.06)",
                    padding: "3rem",
                    border:
                      contactInfo.type === "Scale an existing project"
                        ? `1px solid ${commonCss.blue}`
                        : "none",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleContact("type", "Scale an existing project");
                  }}
                >
                  <Architecture
                    sx={{
                      fontSize: commonCss.cardIconSize,
                      color: commonCss.blue,
                    }}
                  />
                </Paper>
                <Typography
                  sx={{
                    fontWeight: commonCss.cardTitleWeight,
                    fontSize: commonCss.cardTitleSize,
                  }}
                >
                  Scale an existing project
                </Typography>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                  width: "100%",
                  height: "100%",
                  alignItems: "center",
                }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.06)",
                    padding: "3rem",
                    border:
                      contactInfo.type === "Outsourcing"
                        ? `1px solid ${commonCss.blue}`
                        : "none",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleContact("type", "Outsourcing");
                  }}
                >
                  <People
                    sx={{
                      fontSize: commonCss.cardIconSize,
                      color: commonCss.blue,
                    }}
                  />
                </Paper>
                <Typography
                  sx={{
                    fontWeight: commonCss.cardTitleWeight,
                    fontSize: commonCss.cardTitleSize,
                  }}
                >
                  Outsourcing
                </Typography>
              </Box>
            </Grid2>
          </Grid2>
          <Grid2 container sx={{ p: { xs: 0, md: "0 1.5rem" } }} spacing={"1rem"}>
            <Grid2 size={12}>
              <Typography
                sx={{
                  fontSize: commonCss.mainTitleFontSize,
                  fontWeight: commonCss.mainTitleFontWeight,
                }}
              >
                What type of support do you need?
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                  width: "100%",
                  height: "100%",
                  alignItems: "center",
                }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.06)",
                    padding: "3rem",
                    border:
                      contactInfo.service === "Development"
                        ? `1px solid ${commonCss.blue}`
                        : "none",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleContact("service", "Development");
                  }}
                >
                  <Code
                    sx={{
                      fontSize: commonCss.cardIconSize,
                      color: commonCss.blue,
                    }}
                  />
                </Paper>
                <Typography
                  sx={{
                    fontWeight: commonCss.cardTitleWeight,
                    fontSize: commonCss.cardTitleSize,
                  }}
                >
                  Development
                </Typography>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                  width: "100%",
                  height: "100%",
                  alignItems: "center",
                }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.06)",
                    padding: "3rem",
                    border:
                      contactInfo.service === "Design"
                        ? `1px solid ${commonCss.blue}`
                        : "none",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleContact("service", "Design");
                  }}
                >
                  <AccountTree
                    sx={{
                      fontSize: commonCss.cardIconSize,
                      color: commonCss.blue,
                    }}
                  />
                </Paper>
                <Typography
                  sx={{
                    fontWeight: commonCss.cardTitleWeight,
                    fontSize: commonCss.cardTitleSize,
                  }}
                >
                  Design
                </Typography>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                  width: "100%",
                  height: "100%",
                  alignItems: "center",
                }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.06)",
                    padding: "3rem",
                    border:
                      contactInfo.service === "Development & Design"
                        ? `1px solid ${commonCss.blue}`
                        : "none",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleContact("service", "Development & Design");
                  }}
                >
                  <DeveloperMode
                    sx={{
                      fontSize: commonCss.cardIconSize,
                      color: commonCss.blue,
                    }}
                  />
                </Paper>
                <Typography
                  sx={{
                    fontWeight: commonCss.cardTitleWeight,
                    fontSize: commonCss.cardTitleSize,
                  }}
                >
                  Development & Design
                </Typography>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                  width: "100%",
                  height: "100%",
                  alignItems: "center",
                }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.06)",
                    padding: "3rem",
                    border:
                      contactInfo.service === "Others"
                        ? `1px solid ${commonCss.blue}`
                        : "none",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleContact("service", "Others");
                  }}
                >
                  <SettingsSuggest
                    sx={{
                      fontSize: commonCss.cardIconSize,
                      color: commonCss.blue,
                    }}
                  />
                </Paper>
                <Typography
                  sx={{
                    fontWeight: commonCss.cardTitleWeight,
                    fontSize: commonCss.cardTitleSize,
                  }}
                >
                  Others
                </Typography>
              </Box>
            </Grid2>
          </Grid2>
          <Grid2 container sx={{ p: { xs: 0, md: "0 1.5rem" } }} spacing={"1rem"}>
            <Grid2 size={12}>
              <TextField
                fullWidth
                name="name"
                placeholder="Your Name"
                value={contactInfo.name}
                onChange={(e) => handleContact(e.target.name, e.target.value)}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: commonCss.contactUsTextboxGray,
                    },
                  },
                  input: {
                    "&::placeholder": {
                      color: commonCss.darkGray,
                      opacity: 0.9,
                    },
                  },
                }}
              />
            </Grid2>
            <Grid2 size={12}>
              <TextField
              type="email"
                fullWidth
                name="email"
                placeholder="Your Email*"
                value={contactInfo.email}
                onChange={(e) => handleContact(e.target.name, e.target.value)}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: commonCss.contactUsTextboxGray,
                    },
                  },
                  input: {
                    "&::placeholder": {
                      color: commonCss.darkGray,
                      opacity: 0.9,
                    },
                  },
                }}
              />
            </Grid2>
            <Grid2 size={12}>
              <TextField
                fullWidth
                name="phoneno"
                placeholder="Your Phone Number"
                value={contactInfo.phoneno}
                onChange={(e) => handleContact(e.target.name, e.target.value)}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: commonCss.contactUsTextboxGray,
                    },
                  },
                  input: {
                    "&::placeholder": {
                      color: commonCss.darkGray,
                      opacity: 0.9,
                    },
                  },
                }}
              />
            </Grid2>
            <Grid2 container size={12} justifyContent={"flex-end"}>
                 <Button
                                sx={{
                                  backgroundColor: commonCss.buttonBg,
                                  color: commonCss.buttonText,
                                  padding:"0.5rem",
                                  textTransform:"none",
                                  width:{xs:"40%",md:"25%"},
                                  fontWeight:500,
                                  fontSize:"0.95rem",
                                  borderRadius:"30px",
                                  ":hover":{
                                    background:commonCss.blue,
                                  
                                  }
                                }}
                
                                
                              >
                                Send mail
                              </Button>
            </Grid2>
          </Grid2>
        </Paper>
      </Grid2>
      <Grid2 size={12}>
      <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3983.9143433251006!2d101.67307756044637!3d3.1173600692090258!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cc49d6ac5bd58b%3A0x8a573213c3e5c225!2sKL%20Eco%20City%20-%20Menara%202%20%7C%20Management%20Office!5e0!3m2!1sen!2sin!4v1719994313537!5m2!1sen!2sin"
              width="100%"
              height="400"
              style={{border: 0}}
              frameborder="0"
              referrerpolicy="no-referrer-when-downgrade"
            >
            </iframe>
      </Grid2>
    </Grid2>
  );
};

export default ContactUs;
